<div class="app-navbar">
  <nav class="navbar navbar-expand-lg navbar-main">
    <div class="container-fluid navbar-container">
      <div class="navbar-logo-wrapper">
        <img src="assets/images/logo.png" class="navbar-logo" alt="RDA">
      </div>
      <div class="navbar-controls-row">
        @if (isShowBackButton()) {
          <div class="px-2 py-1" (click)="goBack()">
            <span class="fas fa-arrow-left fs-4"></span>
          </div>
        } @else {
          <div
            class="navbar-toggler border border-0"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#navbarOffcanvas"
            aria-controls="navbarOffcanvas"
            aria-label="Toggle navigation"
          >
            <span class="fas fa-bars fs-4"></span>
          </div>
          <div
            class="offcanvas offcanvas-start"
            id="navbarOffcanvas"
            tabindex="-1"
            data-bs-scroll="true"
            data-bs-backdrop="static"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div class="offcanvas-header">
              <div class="offcanvas-title" id="offcanvasNavbarLabel">
                <img src="assets/images/logo.png" class="offcanvas-logo" alt="RDA">
              </div>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div class="offcanvas-body">
              <ul class="navbar-nav">
                <li class="nav-item d-lg-none mb-4">
                  <language-switch />
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/schedule"
                    routerLinkActive="active"
                    class="nav-link"
                    >{{ 'app.navbar.schedule' | translate }}</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/availability"
                    routerLinkActive="active"
                    class="nav-link"
                    >{{ 'app.navbar.availability' | translate }}</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/leave-request"
                    routerLinkActive="active"
                    class="nav-link"
                    >{{ 'app.navbar.leaveRequest' | translate }}</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/account-setting"
                    routerLinkActive="active"
                    class="nav-link"
                    >{{ 'app.navbar.accountSetting' | translate }}</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/personal-info"
                    routerLinkActive="active"
                    class="nav-link"
                    >{{ 'app.navbar.personalInfo' | translate }}</a
                  >
                </li>
                <li class="nav-item">
                  <a (click)="openTermsModal()" class="nav-link">{{
                    'app.navbar.websiteTerms' | translate
                  }}</a>
                </li>
                <li class="nav-item d-flex align-items-center gap-2">
                  <span class="vr d-inline-block"></span>
                  <a (click)="logout()" class="nav-link p-0">{{
                    'app.navbar.logout' | translate
                  }}</a>
                </li>
              </ul>
            </div>
          </div>
        }
        <ng-content />
        <language-switch class="navbar-lang-switch d-none d-lg-block" />
      </div>
    </div>
  </nav>
</div>

@if (showTermsModal) {
  <div class="privacy-overlay" (click)="closeTermsModal()">
    <div class="privacy-modal" (click)="$event.stopPropagation()">
      <div class="privacy-modal-header">
        <h5 class="mb-0">{{ siteTncTitle }}</h5>
        <button type="button" class="btn-close" (click)="closeTermsModal()"></button>
      </div>
      <div class="privacy-modal-body" #tncModalBody (scroll)="onModalScroll($event)">
        @if (loadingPdf) {
          <div class="text-center text-muted py-5">{{ 'app.login.loading' | translate }}</div>
        }
        <div class="pdf-pages" #tncPdfContainer></div>
      </div>
      <div class="privacy-modal-footer">
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="closeTermsModal()">
          {{ 'app.login.close' | translate }}
        </button>
      </div>
    </div>
  </div>
}
